import React from "react";
import NotificationSlider from "components/notification-slider";
import { useSettings } from "hooks/useStore";
import HighlightAnnouncement from "./highlighted";
import clsx from "clsx/lite";

const AnnouncementBar = ({ sliceContext, previewData, pageSettings }) => {
	const { slides, enabled, style } = previewData || sliceContext;
	const { hideNavigation = false, showBlackAnnouncementBar = false,
		hideAnnouncementBar = false, showHighlightedAnnouncement = false } = pageSettings || {};
	const { isMenuOpen } = useSettings(["isMenuOpen"]);

	if (!enabled || hideAnnouncementBar) return null;

	// if (showHighlightedAnnouncement) {
	// 	return <HighlightAnnouncement />;
	// }

	const beigeStyle = style === "gold" && !showBlackAnnouncementBar;

	return (
		<>
			{showHighlightedAnnouncement && <div className="highlight-announcement variation_2"> <HighlightAnnouncement /> </div>}
			<div
				className={clsx(
					"announcement-bar variation_1",
					beigeStyle ? "bg-beige text-black" : "bg-black text-white",
					isMenuOpen ? "h-0 lg:h-10" : "h-10"
				)}>
				<NotificationSlider slides={slides} beigeStyle={beigeStyle} hideNavigation={hideNavigation} />
			</div>
		</>
	);
};

export default AnnouncementBar;